import client from '../httpClient';

const defaultOption = {
  isShowLoading: false,
  isShowMessage: false,
};

// 【customer020】顧客カード画像取得
/**
 * @param {string} cardId
 */
const customerGetCardImageApi = async (cardId) => {
  const result = await client.get(`/customers/card/image/${cardId}`, { ...defaultOption });
  return result;
};

export default customerGetCardImageApi;
